export default ({ commit }) => {
  commit("SET_LOADING");
};
